export const CALCULATION_NOTE_MIN_LENGTH = 10;
export const CALCULATION_NOTE_MAX_LENGTH = 2000;
export const CALCULATION_NOTE_HINT =
  'List the documents and linked sources (connected payroll, bank linking) you used, the ones you left out, and why.';
